import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    tituloEstudoResponsabilidadeCliente,
    tituloEstudoResponsabilidadeConjuge,
} from './EstudoService'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
} from '../../../business-components/Formata/Formata'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    SvgIconDiaDia,
} from '../../../business-components/SvgIcon/SvgIconDespesasTotais/SvgIconDespesasTotais'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    CardGridEstudoTabelaPadrao,
} from './EstudoComp'

const EstudoFormDespesasDiaDiaDespesasVitalicias = ( { values, estudo, report, jsonConfiguracao, indInicial, indFinal } ) => {
    
    const DespesasDiaDiaDespesasVitalicias = () => {

        let headList = [
            {
                colSpan: 7,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.tipoDiaDia, report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.grupoDespesa, report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorMensalAtualQuebraEspecial, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.mesesAteAposentarQuebraEspecial, report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorNaAposentadoriaMensalQuebraEspecial, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.mesesAposAposentarQuebraEspecial, report),
            },
        ]

         if (dadosCompletosCliente(values)) {
            headList.push(
                {
                    colSpan: 5,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoResponsabilidadeCliente(values), report
                            ),
                },
            )
        }
    
        if (dadosCompletosConjuge(values)) {
            headList.push(
                {
                    colSpan: 5,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoResponsabilidadeConjuge(values), report
                            ),
                },
            )
        }

        return (
            <div>
                <TableExibeDados
                    report={report}
                >
                    <TableHeadExibeDados
                        report={report}
                    >
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    <TableBodyExibeDados>
                        {estudo.current.diaDiaDespesasVitalicias?.map((item, ind) => {

                            let colSpan = 0

                            return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        primeiraColuna={true}
                                    >
                                        {item.descricao} 
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.descricaoGrupoDespesa}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.valorMensal}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.tempoValor}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.valorNaAposentadoriaMensal}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.tempoValorNaAposentadoria}
                                    </TableCellBodyExibeDados>
                                    
                                    {dadosCompletosCliente(values) && (
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                        >
                                            {item.valorResponsabilidadeCliente}
                                        </TableCellBodyExibeDados>
                                    )}
                                    
                                    {dadosCompletosConjuge(values) && (
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                        >
                                            {item.valorResponsabilidadeConjuge}
                                        </TableCellBodyExibeDados>
                                    )}
                                </TableRowBodyExibeDados>
                            )
                        })}
                    </TableBodyExibeDados>
                </TableExibeDados>
            </div>
        )
    }

    return (
        <DivFormEstudo>
            {report || relatorioModoApresentacao(values)
                ?
                    //<div
                        //className={(relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                    //>
                    <>
                        <div
                            className={CLASSNAME().formataReportDetalhamento}
                            align='left'
                        >
                            {jsonConfiguracao && jsonConfiguracao.estudoReportDetalhamentoDiaDiaDespesasVitaliciasTextoCabecalho
                                ?
                                    <>
                                        {jsonConfiguracao.estudoReportDetalhamentoDiaDiaDespesasVitaliciasTextoCabecalho}
                                        <br/>
                                        <br/>
                                        <br/>
                                    </>
                                :
                                    MESSAGE().estudoReportDetalhamentoDiaDiaDespesasVitaliciasTextoCabecalho
                            }
                        </div>
                        
                        <DespesasDiaDiaDespesasVitalicias />
                    </>
                    //</div>
                :
                    <CardGridEstudoTabelaPadrao
                        values={values}
                        SvgIcon={SvgIconDiaDia}
                        label={LABEL.diaDiaDespesasVitalicias}
                        helpTextMorte={HELPTEXT.estudoDiaDiaDespesasVitaliciasMorte}
                        helpTextInvalidez={HELPTEXT.estudoDiaDiaDespesasVitaliciasInvalidez}
                        component={<DespesasDiaDiaDespesasVitalicias/>}
                        popup={true}
                    />
            }   
        </DivFormEstudo>
    )
}

export default EstudoFormDespesasDiaDiaDespesasVitalicias